import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=5ac0000c&scoped=true&"
import script from "./Column.vue?vue&type=script&lang=ts&"
export * from "./Column.vue?vue&type=script&lang=ts&"
import style0 from "./Column.vue?vue&type=style&index=0&id=5ac0000c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac0000c",
  null
  
)

export default component.exports